import store from '@/common/store'
import { msgTip } from '@/utils/urlUtils'
import axios from 'axios'
import get from 'lodash/get'

// 精简 axios 封装，由多个 axios 实例，简化为单个 axios 实例，统一配置，移除统一 toast 弹窗与 loading 。
// 创建 axios 实例
const request = axios.create({
  timeout: 100000, // 超时时间
  withCredentials: true
})

// 错误处理 errorHandler
const errorHandler = (error) => {
  const status = String(get(error, 'response.status'))
  // code 429 全都需要抛出异常
  if (status == '429') {
    error.message = error.response.data.error
    msgTip({
      type: 'error',
      msg: error.message
    })
  }
  return Promise.reject(error)
}

// 请求拦截器
request.interceptors.request.use((config) => {
  return config
}, errorHandler)

// 响应拦截器
request.interceptors.response.use((response: any) => {
  // 下载文件
  if (response.request.responseType === 'blob') {
    return response
  }
  const data = response.data
  const { success, error, redirect_url } = data
  // 根据 success 进行判断
  if (success) {
    return data
  } else {
    // 处理登录失效
    if (error && error.includes('请登录')) {
      store.commit('SET_USER_INFO', null)
      store.commit('SET_LOGINMODAL', true) // 弹窗
    }
    // 处理行为验证
    if (error && error.includes('行为验证')) {
      store.commit('SET_BEHAVIOR_STATUS', {}) // 弹窗
    }
    // 处理重定向
    if (redirect_url) {
      window.location.replace(response.data.redirect_url) // 重定向
    }
    // success = false 返回值
    return data
  }
}, errorHandler)

export default request
